// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

import mainOidc from "../dealer_area/auth";
import Vue from 'vue'
import {BootstrapVue, BootstrapVueIcons} from 'bootstrap-vue'
import Vuex from 'vuex'
import VueI18n from 'vue-i18n'
import Notifications from 'vue-notification';
import datepicker from 'vue-bootstrap-datetimepicker';
import 'pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css';
import moment from 'moment-timezone';
import VueBrowserUpdate from 'vue-browserupdate';
import Multiselect from 'vue-multiselect'
import VueQRCodeComponent from 'vue-qr-generator'

import App from '../js/App.vue'
import store from './store'
import router from './router'
import i18n from '../js/services/locale'
import "../js/services/vee-validate";
import {errorResponseHandler} from "../js/services/errorHandler";

require('../js/bootstrap');

Vue.use(BootstrapVue);
Vue.use(BootstrapVueIcons);
Vue.use(Vuex);
Vue.use(VueI18n);

Vue.use(Notifications);
Vue.use(datepicker);
Vue.use(VueBrowserUpdate, {
    options: {},
    test: false,
});

Vue.filter('formatDatePipe', function(value, timezone = null, format = null) {
    if (value) {
        let date = moment.utc(String(value))
        if(timezone && timezone.name) date.tz(timezone.name);
        return date.format(format !== null && typeof format !== 'undefined' ? format : 'DD/MM/YYYY HH:mm:ss');
    }
});
Vue.filter('formatDate', function(value, timezone = null, format = null) {
  if (value) {
    let date = moment.utc(String(value))
    if(timezone && timezone.name) date.tz(timezone.name);
    return date.format(format !== null && typeof format !== 'undefined' ? format : 'DD/MM/YYYY HH:mm:ss');
  }
});

Vue.prototype.moment = moment
Vue.prototype.$xmarket_url = process.env.MIX_XMARKET_URL || 'https://xmarket.rch.it';
Vue.prototype.$ats_admin_url = process.env.MIX_ATS_ADMIN_URL || 'https://ats-admin.rch.it';

Vue.component('multiselect', Multiselect)
Vue.component('qr-code', VueQRCodeComponent)

String.prototype.ucfirst = function() {
    return this.charAt(0).toUpperCase() + this.slice(1)
}

Vue.prototype.$http = axios;

Vue.prototype.$http.interceptors.response.use(
    (response) => response,
    errorResponseHandler
);


mainOidc.useRouter(router);
mainOidc.startup().then((ok) => {
    if (ok) {
        const app = new Vue({
            el: '#app',
            i18n,
            store,
            router,
            template: '<App/>',
            components: {
                App
            },
            data: () => ({
                alerts: null,
            }),
            created: async function () {
                this.guessLanguage();
                this.loadTranslations();
                store.commit('account/set_group', 'dealer');
            },
            methods: {
                guessLanguage: function () {
                    // Load language code from path
                    const path = window.location.pathname.split('/');
                    if (path[1] && path[1].length === 2) {
                        localStorage.setItem('language', path[1]);
                    }
                },
                loadTranslations: function () {
                    const lang = localStorage.getItem('language');
                    if (lang) {
                        store.dispatch('account/updateLanguage', lang).then(() => {
                        })
                    }
                },
            }
        });
    } else {
        console.error("Oidc: Startup was not ok");
    }
});

